import React from 'react';
import { Images, attributeTypes } from 'utils';
import { Checkbox } from '@mui/material';

export const LayoutSection = ({ selectedItem, handleUpdate, index }) => {
    const fullWidthOnly = [
        attributeTypes.RICH_TEXT,
        attributeTypes.TABLE,
        attributeTypes.SESSION_DATA_TABLE,
        attributeTypes.GRAPH,
        attributeTypes.TARGET,
    ].includes(selectedItem?.type);
    const halfWidthMax = [attributeTypes.SIGNATURE, attributeTypes.UPLOAD].includes(selectedItem?.type);
    const widthOptions = fullWidthOnly ? ['Full'] : halfWidthMax ? ['Full', '1/2'] : ['Full', '1/2', '1/3', '1/4'];

    return (
        <>
            <div className="properties-section">
                <div className="section-header">
                    <img src={Images.layoutIcon} alt="close" />
                    <span>LAYOUT</span>
                </div>
                <>
                    <div className="props-label">Width</div>
                    <div className="width-selector">
                        {widthOptions.map((opt) => (
                            <div
                                key={opt}
                                className={`width-option ${selectedItem?.properties?.width === opt ? 'active' : opt === 'Full' && !selectedItem?.properties?.width ? 'active' : ''}`}
                                onClick={() => handleUpdate('width', opt)}
                            >
                                {opt}
                            </div>
                        ))}
                    </div>

                    {selectedItem?.type !== attributeTypes.GRAPH && selectedItem?.type !== attributeTypes.TABLE && (
                        <div className="inline-check-wrapper">
                            <div className="checkbox-label">
                                <Checkbox
                                    onClick={() => handleUpdate('inline', !selectedItem?.properties?.inline)}
                                    name={'inline'}
                                    style={{
                                        padding: 0,
                                        color: selectedItem?.properties?.inline ? '#0C66E4' : '#D0D5DD',
                                        cursor: 'pointer',
                                    }}
                                    checked={Boolean(selectedItem?.properties?.inline)}
                                />
                                <div>
                                    <p className="inline-width">Inline with previous</p>
                                    <p className="inline-helper"> Try to fit on same line if space allows</p>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            </div>
        </>
    );
};
